'use strict';

var _ = require('lodash');
var FilterPanelService = function FilterPanelService(SearchCriteriaRule) {
  function getSearchCriteriaRulesForOneMarketOnly(criteria, currentMarket) {
    var firstMarketFromSearch = _.find(criteria.rules, function (rule) {
      return rule.criterion === 'Market';
    });
    var newCriteriaWithoutMarkets = _.filter(criteria.rules, function (rule) {
      return rule.criterion !== 'Market';
    });
    var marketCriteriaElement = new SearchCriteriaRule({
      field: 'custom:market',
      operator: '=',
      leftOperand: currentMarket,
      metaCategory: firstMarketFromSearch ? firstMarketFromSearch.metaCategory : undefined
    });
    newCriteriaWithoutMarkets.push(marketCriteriaElement);
    return newCriteriaWithoutMarkets;
  }
  return {
    getSearchCriteriaRulesForOneMarketOnly: getSearchCriteriaRulesForOneMarketOnly
  };
};
FilterPanelService.$inject = ['SearchCriteriaRuleFactory'];
module.exports = FilterPanelService;